/* eslint-disable import/no-cycle */
import roleEnum from '@/common/role.enum'
import AuthProvider from '@/resources/AuthProvider'

const AuthService = new AuthProvider()

const state = {
  accessToken: '',
  user: {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    userGroupId: '',
    allowedGroupIds: [],
    allowedTeamIds: []
  }
}

const getters = {
  user: (state) => state.user,
  accessToken: (state) => state.accessToken
}

const mutations = {
  SET_USER (state, payload) {
    state.accessToken = payload.token
    state.user.id = payload.id
    state.user.firstName = payload.firstName
    state.user.lastName = payload.lastName
    state.user.email = payload.email
    state.user.role = payload.role
    state.user.userGroupId = payload.groupService
    state.user.allowedGroupIds = payload.allowedGroupIds || []
    state.user.allowedTeamIds = payload.allowedTeamIds || []
  },

  RESET_USER (state) {
    state.accessToken = ''
    state.user.id = ''
    state.user.firstName = ''
    state.user.lastName = ''
    state.user.email = ''
    state.user.role = ''
    state.user.userGroupId = ''
    state.user.allowedGroupIds = []
    state.user.allowedTeamIds = []
  }
}

const actions = {
  async signIn ({ dispatch }, payload) {
    const { data } = await AuthService.login({ username: payload.username, password: payload.password })
    const user = { ...data.user }
    user.ability = [{ action: 'manage', subject: 'all' }]
    localStorage.setItem('userData', JSON.stringify(user))
    const accessRoles = [roleEnum.SUPER_ADMIN, roleEnum.SUPERVISOR, roleEnum.MANAGER, roleEnum.MANAGEMENT]
    if (!accessRoles.includes(data?.user?.role)) throw new Error('Unauthorized')
    if (data.token) {
      dispatch('setUser', {
        ...data.user,
        token: data.token
      })
    }
  },

  resetUser ({ commit }) {
    commit('RESET_USER')
  },

  setUser ({ commit }, payload) {
    commit('SET_USER', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
